import { useEffect, useState } from 'react';
import { IconEye, IconEyeOff } from '@tabler/icons-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { USE_MOCKS } from '../api/config';
import { MOCK_ADMIN_LOGIN, MOCK_ADMIN_PASSWORD } from '../api/mocks/credentials';
import { useAuth } from '../context/AuthContext';
import FormField from '../components/ui/FormField';
import ErrorMessage from '../components/ui/ErrorMessage';
import Loader from '../components/ui/Loader';
import './LoginPage.scss';

export default function LoginPage() {
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { login: authLogin, isAuthenticated, isLoading } = useAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (isAuthenticated) {
            const redirect = searchParams.get('redirect') || '/';
            navigate(redirect.startsWith('/') ? redirect : '/', { replace: true });
        }
    }, [isAuthenticated, navigate, searchParams]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!login.trim() || !password) {
            setError('Введите логин и пароль');
            return;
        }

        setLoading(true);
        setError('');
        try {
            await authLogin(login, password);
            const redirect = searchParams.get('redirect') || '/';
            navigate(redirect.startsWith('/') ? redirect : '/', { replace: true });
        } catch (err) {
            setError(err.message || 'Ошибка входа');
        } finally {
            setLoading(false);
        }
    };

    if (isLoading || isAuthenticated) {
        return <Loader text="Проверяем сессию..." />;
    }

    return (
        <div className="admin-login">
            <div className="admin-login__card card">
                <div className="admin-login__header">
                    <span className="admin-login__logo">BP</span>
                    <h1>BypassVPN АДМИН</h1>
                    <p>Вход для администраторов</p>
                    {USE_MOCKS && (
                        <p className="admin-login__mock-hint">
                            Режим моков: {MOCK_ADMIN_LOGIN} / {MOCK_ADMIN_PASSWORD}
                        </p>
                    )}
                </div>

                <form onSubmit={handleSubmit} noValidate>
                    <ErrorMessage message={error} />

                    <FormField
                        label="Логин"
                        value={login}
                        onChange={(e) => setLogin(e.target.value)}
                        placeholder="admin"
                        autoComplete="username"
                    />

                    <FormField
                        label="Пароль"
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="••••••••"
                        autoComplete="current-password"
                        rightElement={(
                            <button
                                type="button"
                                className="admin-login__toggle"
                                onClick={() => setShowPassword(!showPassword)}
                                aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                            >
                                {showPassword ? (
                                    <IconEyeOff size={18} stroke={1.5} />
                                ) : (
                                    <IconEye size={18} stroke={1.5} />
                                )}
                            </button>
                        )}
                    />

                    <button
                        type="submit"
                        className="btn btn--primary btn--block"
                        disabled={loading || !login.trim() || !password}
                    >
                        {loading ? 'Входим...' : 'Войти'}
                    </button>
                </form>
            </div>
        </div>
    );
}
